/*
========================================
PRODUCT PREVIEW

BLOCK: PRICE & CART

Отвечает за:
- кнопку корзины
- отображение текущей цены
- отображение старой цены
- отображение скидки
- оформление ценового блока

Не содержит:
- изображения
- шторки
========================================
*/

type ProductPreviewPriceCartProps = {
  addToCartLabel: string
  resolvedPrice?: string | null
  resolvedOriginalPrice?: string | null
  hasDiscount: boolean
  onAddClick?: () => void
}

export default function ProductPreviewPriceCart({
  addToCartLabel,
  resolvedPrice,
  resolvedOriginalPrice,
  hasDiscount,
  onAddClick,
}: ProductPreviewPriceCartProps) {

  return (
    <div className="mt-5 flex items-stretch gap-3">
   <button
  type="button"
  onClick={onAddClick}
  className="
    group relative
    inline-flex min-h-[48px] min-w-[150px] items-center justify-center gap-2
    rounded-3xl
    bg-gradient-to-r from-green-700 to-green-600
    px-4 py-2
    text-sm font-extrabold uppercase tracking-wide
    text-white
    shadow-[0_4px_8px_rgba(0,0,0,0.8),0_2px_2px_rgba(0,0,0,0.8)]
    hover:shadow-[0_12px_16px_rgba(0,0,0,0.45),0_6px_6px_rgba(0,0,0,0.28)]
    hover:brightness-110
    hover:-translate-y-1
    active:scale-[0.97]
    border border-black/20
    transition-all duration-300
    animate-cartInviteLift
  "
>
  <span className="relative z-10">{addToCartLabel}</span>

  <span
    className="
      pointer-events-none
      absolute -top-3 -right-3 z-20
      flex h-8 w-8 items-center justify-center
      rounded-full
      bg-orange-500
      shadow-[0_6px_12px_rgba(0,0,0,0.35)]
      transition-transform duration-300
      group-hover:scale-110
    "
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-4 w-4 text-white"
    >
      <path d="M2.25 3A.75.75 0 0 1 3 2.25h1.386c.334 0 .623.221.709.543l.525 1.957H20.25a.75.75 0 0 1 .728.93l-1.5 6A.75.75 0 0 1 18.75 12H7.31l.4 1.5H18a.75.75 0 0 1 0 1.5H7.125a.75.75 0 0 1-.724-.555L4.04 5.25H3A.75.75 0 0 1 2.25 4.5V3Zm6.75 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8.25 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" />
    </svg>
  </span>

  {/* контейнер, который обрезает только блик */}
<span className="pointer-events-none absolute inset-0 z-0 overflow-hidden rounded-3xl">
  <span className="shine-diagonal-bidirectional absolute inset-0" />
</span>
</button>

     <div className="
  relative
  flex min-h-[38px] min-w-[70px] flex-col items-end justify-center
  rounded-2xl
  bg-white
  px-4 py-3
  text-right
  shadow-md
">


        {hasDiscount ? (
          <>
            <div className="text-xs font-semibold uppercase tracking-wide text-black/45 line-through">
              {resolvedOriginalPrice}
            </div>
            <div className="mt-0.5 text-lg font-extrabold leading-none text-black">
              {resolvedPrice}
            </div>
          </>
        ) : (
          <>
            <div className="mt-0.5 text-lg font-extrabold leading-none text-black">
              {resolvedPrice || "—"}
            </div>
          </>
        )}
      </div>
<div className="
  relative
  flex min-h-[38px] min-w-[80px] flex-col items-end justify-center
  rounded-2xl
  bg-white
  px-4 py-3
  text-right
  shadow-md
">5.99
</div>


    </div>
  )
}